import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import "../Membership/membershipList.css";
import MembershipCard from "../../Components/MembershipCard/MembershipCard";
import axiosInstance from "../../Services/axios";
import { toast } from 'react-toastify';
import ReactLoading from "react-loading";
import { GoDotFill } from "react-icons/go";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useSelector } from "react-redux";
import { fetchVendorMembershipDetails } from "../../Services/api";
import { showToast } from "../../Components/toastConfig/ToastConfig";

const MemberShipDetails = () => {
  const location = useLocation();
  const [membershipDetails, setMembershipDetails] = useState([]);
  const [VendorDetails, setVendorDetails] = useState();
  const { vendor_Id, membershipiD, from_Page, vendorName } = location.state || {};
  const [offertime, setOffertime] = useState([]);
  const [profile, setProfile] = useState();
  const [membershipID, setMembershipID] = useState();
  const [showModal, setShowModal] = useState(false);
  const state = useSelector((state) => state);
  const [userData, serUserData] = useState(state?.userAuth?.user);
  let { vendorId, membership_ID } = useParams();
  const [pageLoaded, setPageLoaded] = useState(false);
  const [purchased_status, setPurchased_status] = useState('')
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMgs, setModalMgs] = useState('')

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const sym = Symbol('key');
  const obj = {
    [sym]: 'value'
  };

  const navigate = useNavigate();

  const [isTouch, setIsTouch] = useState(false);

  const handleTouch = () => {
    setIsTouch(!isTouch);
  };

  useEffect(() => {
    if (userData.user_type != "Guest") {
      membershipStatusCheck()
      membershipdetail();
    } else {
      membershipdetail();
    }
  }, []);

  useEffect(() => {
    if (VendorDetails?.membership_status == 0) {
      setModalMgs('Memberships are currently unavailable. The merchant has disabled Memberships for this store.');
      setModalOpen(true)
    }
  }, [VendorDetails])

  const membershipStatusCheck = async () => {
    try {
      let reqData = {
        vendor_id: vendorId,
        membership_id: membership_ID,
      };
      const res = await fetchVendorMembershipDetails(reqData);
      if (res?.status == 200) {

        const data = res.data
        setPurchased_status(data.purchased_status)
        setPageLoaded(true);
      }
    } catch (err) {
      if (err.response.status == 400 || err.response.status == 500) {
        showToast(err.response || "Something went wrong, please try again later", "error");
      }
    }
  };

  const confirmPaymentBuyNow = () => {
    if (userData.user_type != "Guest") {
      if (purchased_status == true) {
        toast.error("Membership has already been purchased.", { position: toast.POSITION.BOTTOM_CENTER, });
      } else {
        try {
          BuyNow();
        } catch (error) {
          console.error("Error in BuyNow:.....", error);
        }
      }
    } else {
      handleShow();
    }

  };

  const BuyNow = () => {
    navigate("/BuyNow", { state: { vendorId: profile.vendor_id, membership_ID: membershipID, flowParent: "buy", from_Page: from_Page }, });
  };


  const membershipdetail = async() => {
    try {
      let reqData = {
        vendor_id: vendorId,
        membership_id: membership_ID,
      };
      let res = await fetchVendorMembershipDetails(reqData);
      if (res?.status == 200) {
        setMembershipDetails(res?.data?.membership_detail);
        setVendorDetails(res?.data?.vendor_details);
        setOffertime(res?.data?.membership_detail?.membership_availability);
        setProfile(res?.data);
        setMembershipID(res?.data?.membership_detail?.membership_id);
        setPageLoaded(true);
        sessionStorage.removeItem('membership')
      }
    } catch (err) {
      if (err.response.status == 400 || err.response.status == 500) {
        showToast(err.response || "Something went wrong, please try again later", "error");
      }
    }
  };


  const handleLoginNavigate = () => {
    localStorage.setItem('vendorUrl', location.pathname);
    navigate('/login', { state: { fromGuest: true } });
  };
  const handelNavigate = () => {
    navigate(`/vendor/${vendorId}`);
  }



  return (
    <>
      <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white ">
        <div className="d-flex justify-content-between align-items-center ms-2 me-2">
          <img
            src={p_nav_previous}
            width="24"
            height="16"
            alt="Previous Button"
            role="button"
            onClick={() => {
              if (from_Page == "search_page")
                navigate("/search-store", { state: { from_Page: "Member_ship" } });
              else if (from_Page == "Buynow" || from_Page == undefined)
                navigate(`/MembershipBuyNow/${vendorId}`, { state: { from_Page: "Membershipdetail" } });
              else
                navigate(-1);
            }}
          />

          <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">Membership</div>
        </div>
      </div>
      <div className="p-3">
        <p className="ff-poppins-bold fs-24 ms-2 secondary-text m-0"> {vendorName}</p>
        {/* <p className="ff-poppins-regular fs-16 secondary-text-1">
          Membership
        </p> */}
      </div>
      {
        pageLoaded ?
          <>
            <div>
              <div className="p-2 scroller-style-y">

                <div>

                  <div className="pb-3">
                    {

                      membershipDetails && VendorDetails ? (
                        <MembershipCard cardColor={membershipDetails.card_color}
                          data={{ membershipDetails, VendorDetails }} buttonName="Subscription"
                          Membership_from_Page="Membership_details"
                        />
                      ) : (
                        <></>
                      )
                    }
                  </div>
                  <hr />
                  <p className="m-0 ff-poppins-semiBold fs-17 p-2">
                    Membership Description
                  </p>
                  <p className="m-0 ff-poppins-regular fs-14 p-2">  {membershipDetails?.membership_description} </p>
                </div>
                <div className="d-flex mt-3">
                  <div className="d-flex justify-content-center col-6">
                    <div className="membershipListBox">
                      <p className="ff-poppins-semiBold m-0 fs-17">Price</p>
                      <p className="ff-poppins-semiBold m-0 fs-24 primary-text">
                        <span className="rupeeIcon ">₹</span>{membershipDetails?.price}
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center col-6">
                    <div className="membershipListBox">
                      <p className="ff-poppins-semiBold m-0 fs-17">Validity</p>
                      <div className="d-flex align-items-center">
                        <p className="ff-poppins-semiBold m-0 fs-30 primary-text">
                          {membershipDetails?.price_duration < 10
                            ? `${membershipDetails?.price_duration}`
                            : membershipDetails?.price_duration}{" "}
                        </p>
                        <p className="ff-poppins-regular m-0 fs-9 ps-1">
                          Months from the date of purchase
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex mt-3">
                  {membershipDetails?.services_count != 0 &&
                    <div className="d-flex justify-content-center col-6">
                      <div className="membershipListBox">
                        <p className="ff-poppins-semiBold m-0 fs-17">Services</p>
                        <div className="d-flex align-items-center">
                          <p className="ff-poppins-semiBold m-0 fs-30 primary-text">
                            {membershipDetails?.services_count?.toString().padStart(2, '0')}
                          </p>
                          <p className="ff-poppins-regular m-0 fs-9 ps-1">Services</p>
                        </div>
                      </div>
                    </div>
                  }
                  <div className="d-flex justify-content-center col-6">
                    <div className="membershipListBox">
                      <p className="ff-poppins-semiBold m-0 fs-17">Products</p>
                      <div className="d-flex align-items-center">
                        <p className="ff-poppins-semiBold m-0 fs-30 primary-text">
                          {membershipDetails?.products_count?.toString().padStart(2, '0')}
                        </p>
                        <p className="ff-poppins-regular m-0 fs-9 ps-1">products</p>
                      </div>
                    </div>
                  </div>

                  {
                    membershipDetails?.services_count == 0 &&

                    <div className="d-flex justify-content-center col-6">
                      <div className="membershipListBox">
                        <p className="ff-poppins-semiBold m-0 fs-17">Discount</p>
                        <div className="d-flex align-items-center">
                          <p className="ff-poppins-semiBold m-0 fs-30 primary-text">
                            {membershipDetails?.discount}%
                          </p>
                          <p className="ff-poppins-regular m-0 fs-9 ps-1">
                            Discount on eligible services & products
                          </p>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                {membershipDetails?.services_count != 0 &&
                  <div className="d-flex mt-3">
                    <div className="d-flex justify-content-center col-6">
                      <div className="membershipListBox">
                        <p className="ff-poppins-semiBold m-0 fs-17">Discount</p>
                        <div className="d-flex align-items-center">
                          <p className="ff-poppins-semiBold m-0 fs-30 primary-text">
                            {membershipDetails?.discount}%
                          </p>
                          <p className="ff-poppins-regular m-0 fs-9 ps-1">
                            Discount on eligible services & products
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>}
                <div className="m-1 p-2 border rounded my-4">
                  <p className="ff-poppins-semiBold fs-15 m-0">Available Hours</p>
                  {offertime.map((time) => {
                    return (
                      <div className="d-flex justify-content-between p-1">

                        <p className="p-0 ff-poppins-regular fs-12  primary-text m-0">{time.day} </p>
                        <p className="p-0 ff-poppins-regular fs-12  m-0">{time.timing} </p>


                      </div>
                    );
                  })}
                </div>
                <div>
                  <p className="ff-poppins-regular fs-12 m-0 p-2">
                    Membership{" "} Terms & Condition  </p>

                  <div className="d-flex">
                    <span className="ff-poppins-regular fs-12"> <GoDotFill /></span>
                    <p
                      className="fs-10 ff-poppins-regular ms-1"
                      dangerouslySetInnerHTML={{
                        __html: membershipDetails?.terms_and_conditions?.replace(/\n/g, "<br/>")
                      }}
                    ></p>
                  </div>

                </div>


                <div className="p-2 booknowBtn mb-4" >
                  <button onClick={() => confirmPaymentBuyNow()} className="ff-poppins-regular fs-14 rounded-5 primary-bg text-white w-100 mt-1 butNowBtnMembership"  >
                    Buy Now
                  </button>
                </div>

              </div>
            </div>
          </>

          :
          <div className='d-flex justify-content-center skeleton-bg'>
            <div >
              <Skeleton height={190} width={375} borderRadius={10} />
              <Skeleton height={190} width={375} borderRadius={10} />
              <Skeleton height={190} width={375} borderRadius={10} />
              <Skeleton height={190} width={375} borderRadius={10} />
            </div>
          </div>
      }

      {
        showModal && (
          <div className="modal-backdrop show"></div>
        )
      }
      {
        modalOpen && (
          <div className="modal fade show successModal bg-white" tabIndex="-1"  >
            <div className="modal-dialog modal-dialog-centered modal-sm m-0">
              <div className="modal-content">
                <div className="modal-body ps-3 pe-3 pt-4 pb-4">
                  <div className='text-center ff-poppins-medium fs-12'>{modalMgs}</div>

                  <div className="d-flex justify-content-center mt-3">
                    <button type="button" className="col-5 ouline-none border-none rounded-3 primary-bg text-light p-2 ff-poppins-medium fs-13" onClick={() => handelNavigate()} >Click here</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        showModal && (
          <div className="modal justify-content-center" tabIndex="-1" style={{ display: 'block' }}>
            <div className="modal-dialog-centered loginWarningDialog">
              <div className="modal-content">
                <div className="modal-body">
                  <div className='ff-poppins-semiBold fs-1 primary-text text-center'>
                    Attention!
                  </div>
                  <div className='ff-poppins-regular fs-14 text-center mt-2'>
                    To proceed further you need to login/register and get access to all the features.
                  </div>
                  <div className='d-flex justify-content-center align-items-center mt-1 mb-1' role='button' onClick={() => navigate('/login', { state: { fromGuest: true } })}>
                    <div className='loginBtn primary-bg text-center text-white p-1 ff-poppins-medium fs-16'>Login</div>
                  </div>
                  <div className='d-flex justify-content-center align-items-center' role='button' onClick={handleClose}>
                    <div className='loginBtn text-center text-secondary p-1 ff-poppins-medium fs-16 secondary-bg-1 mt-2'>Close</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </>
  );
};
export default MemberShipDetails;
